import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=16bac7d4&scoped=true&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=16bac7d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bac7d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\maixun_cxx\\private_library\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16bac7d4')) {
      api.createRecord('16bac7d4', component.options)
    } else {
      api.reload('16bac7d4', component.options)
    }
    module.hot.accept("./ResetPassword.vue?vue&type=template&id=16bac7d4&scoped=true&", function () {
      api.rerender('16bac7d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ResetPassword.vue"
export default component.exports